// Componente pill multi/single-select riutilizzabile.
// Props:
//   - mode: 'multi' | 'single' (default 'multi')
//   - options: [{ value: string, label: string, icon?: string (classe Flaticon es. 'fi fi-rr-paw') | ReactNode }]
//   - selected: string | string[]
//   - onChange: (next: string | string[] | null) => void
const PillSelect = ({ mode = 'multi', options, selected, onChange }) => {
    const isSelected = (val) => {
        if (mode === 'single') return selected === val;
        return Array.isArray(selected) && selected.includes(val);
    };

    const handleClick = (val) => {
        if (mode === 'single') {
            onChange(selected === val ? null : val);
            return;
        }
        const current = Array.isArray(selected) ? selected : [];
        const next = current.includes(val)
            ? current.filter(v => v !== val)
            : [...current, val];
        onChange(next);
    };

    const renderIcon = (icon) => {
        if (!icon) return null;
        if (typeof icon === 'string') return <i className={`${icon} leading-none`}></i>;
        return icon;
    };

    return (
        <div className="flex flex-wrap gap-2">
            {options.map((opt) => {
                const active = isSelected(opt.value);
                return (
                    <button
                        key={opt.value}
                        type="button"
                        onClick={() => handleClick(opt.value)}
                        className={`
                            flex items-center gap-2 px-3 py-1.5 rounded-full text-sm
                            border transition-colors
                            ${active
                                ? 'bg-[#225424] text-white border-[#225424]'
                                : 'bg-white text-neutral-700 border-neutral-200 shadow-sm hover:border-neutral-400'}
                        `}
                    >
                        {renderIcon(opt.icon)}
                        <span className="whitespace-nowrap">{opt.label}</span>
                        {active && <i className="fi fi-rr-check text-xs leading-none"></i>}
                    </button>
                );
            })}
        </div>
    );
};

export default PillSelect;
